// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import NumberInputField from "src/components/shared/inputs/NumberInputField/NumberInputField";

// Constants
import { MAX_RX_AXIS_VALUE, MIN_RX_AXIS_VALUE } from "src/constants/enums";

const MAX_SPHERE_CYLINDER = 100;
const MIN_SPHERE_CYLINDER = -100;

type PrescriptionType = {
  cylinder: string;
  sphere: string;
  axis: string;
};

type TrialPrescriptionInputsType = {
  prescription: PrescriptionType;
  onPrescriptionChange: (prescription: PrescriptionType) => void;
};

const TrialPrescriptionInputs = ({
  prescription,
  onPrescriptionChange,
}: TrialPrescriptionInputsType) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" gap="8px" width="100%">
      <NumberInputField
        id="trial-prescription-sphere-input"
        value={prescription.sphere}
        placeholder={t("Sphere")}
        onChange={(e) => {
          onPrescriptionChange({
            ...prescription,
            sphere: e.target.value,
          });
        }}
        min={MIN_SPHERE_CYLINDER}
        max={MAX_SPHERE_CYLINDER}
      />
      <NumberInputField
        id="trial-prescription-cylinder-input"
        value={prescription.cylinder}
        placeholder={t("Cylinder")}
        onChange={(e) => {
          onPrescriptionChange({
            ...prescription,
            cylinder: e.target.value,
          });
        }}
        min={MIN_SPHERE_CYLINDER}
        max={MAX_SPHERE_CYLINDER}
      />
      <NumberInputField
        id="trial-prescription-axis-input"
        value={prescription.axis}
        placeholder={t("Axis")}
        onChange={(e) => {
          onPrescriptionChange({
            ...prescription,
            axis: e.target.value,
          });
        }}
        min={MIN_RX_AXIS_VALUE}
        max={MAX_RX_AXIS_VALUE}
      />
    </Box>
  );
};

export default TrialPrescriptionInputs;
